import InputForm from './InputForm';
export default InputForm;



// WEBPACK FOOTER //
// ./src/components/common/InputForm/index.js